import { obterHtml, obterJson } from './v2/api';
import { formatar, url, urlApi } from './v2/config';
import { iniciarAutocomplete } from './v2/campoBusca';
import { escolherLocal, guardarBuscaRecente, guardarOndeParou, localDaConexao, localEscolhido, pedirLocalizacao, slugDoLocal, urlBusca } from './v2/local';
import { iniciarMedicaoPagina, registrarEvento } from './v2/medicao';
import { avisarErro } from './v2/aviso';
import { ocupado, ocupar } from './v2/botao';
import { irPara } from './v2/sobreposicao';
import { obterUsuario } from './v2/usuario';
import { abrirSov, fecharSov, iniciarBuscaTelaCheia, textosBusca } from './v2/buscaTelaCheia';
import { abrirAlertaDaBusca, alertaPedidoNaUrl, obterAlertaDaBusca } from './v2/alertaJanela';
import { salvasNaConta, vagasSalvas } from './v2/salvas';
import { abrirNoSheet, abrirSheet, esqueletoVaga, fecharCompartilhar, fecharSheet, iniciarVaga, mostrarVagaDoHistorico, prefetch, remarcarCartoes, selecionarNoPainel, vagaSelecionada } from './v2/vaga';

// Busca da v36 (renderFbar, openFacet, applyAndRender...). O servidor monta a lista; aqui ficam os filtros, o painel
// e o pedaço ?parcial=lista que troca a coluna da lista a cada filtro.
const $ = id => document.getElementById(id);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const ico = (n, cls = '') => `<svg class="ico ${cls}" aria-hidden="true"><use href="#i-${n}"></use></svg>`;
const fmt = n => Number(n).toLocaleString(document.documentElement.lang || 'pt-BR');
const skLinha = (w, h = 12) => `<span class="sk" style="width:${w};height:${h}px"></span>`;
const skCartao = () => `<li class="card card--sk" aria-hidden="true"><span class="card__logo sk"></span><div class="card__top">${skLinha('45%')}${skLinha('44px')}</div>${skLinha('70%', 16)}${skLinha('40%')}${skLinha('55%')}</li>`;
const ehCelular = () => !window.matchMedia('(min-width: 960px)').matches;
const cliqueComum = e => e.button === 0 && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey;
const lerJson = id => { try { return JSON.parse($(id)?.textContent || 'null'); } catch { return null; } };

const T = lerJson('busca-v2-textos') || {};
const D = lerJson('busca-v2');
const modoSalvas = !!document.querySelector('.split[data-salvas]');
const G = D?.grupos || [];
const GMAP = Object.fromEntries(G.map(g => [g.k, g]));
// Rótulo de cada opção que já chegou (página, lista inteira, pedaço da lista), para o chip da escolhida fora das 30 cidades.
const _rotulosVistos = {};
const guardarRotulos = (k, ops) => (ops || []).forEach(o => { _rotulosVistos[`${k}:${o[0]}`] = String(o[1]).split(' (')[0]; });
G.forEach(g => guardarRotulos(g.k, g.ops));

// ---------- estado (os códigos da URL) ----------
const vazioF = () => Object.fromEntries(G.map(g => [g.k, g.tipo === 'multi' ? [] : g.tipo === 'toggle' ? false : '']));
const S = {
    f: vazioF(),
    ordem: D?.ordem || '',
    ponto: D?.ponto || null,
    rascunho: null,
    popEmpilhou: false
};
G.forEach(g => {
    S.f[g.k] = g.tipo === 'multi' ? [...g.sel] : g.tipo === 'toggle' ? g.sel.length > 0 : (g.sel[0] || '');
});

const ativos = (f = S.f) => G.reduce((a, g) => a + (g.tipo === 'multi' ? f[g.k].length : f[g.k] ? 1 : 0), 0);
const ligado = (g, f = S.f) => (g.tipo === 'multi' ? f[g.k].length > 0 : !!f[g.k]);
const gruposLigados = f => G.filter(g => ligado(g, f));
const ordens = () => (D?.ordens || []).filter(o => o[0] !== 'perto' || S.ponto);

// Link do alerta com cidade e trabalho remoto (?cidade= com ?modalidade= 2/4, ou o ?ou=remoto que a busca leva adiante): a lista
// junta "cidade OU remoto" enquanto a região e a modalidade estão ligadas (VagasController._cidadeOuRemotoV2 confere).
const ouRemotoNaUrl = p => {
    const m = p.getAll('modalidade').map(v => v.trim()).filter(Boolean);
    return p.get('ou') === 'remoto' || (p.getAll('cidade').some(v => v.trim()) && m.length > 0 && m.every(v => v === '2' || v === '4'));
};

// Parâmetros na ordem fixa do servidor (§6.2 regra 5): perto, os filtros na ordem dos grupos e a ordem.
// A vírgula do ponto vai crua, como o servidor escreve: "%2C" seria outra chave de cache para a mesma página.
// novaBusca: os filtros que vão para outro cargo ou local (o painel "Filtros"), sem a busca do endereço de hoje; sem
// manterLugar (o local mudou), sem o ponto e sem os filtros de lugar.
const _gruposDeLugar = ['regiao', 'raio', 'estado'];
function qsDe(f = S.f, ordem = S.ordem, { novaBusca = false, manterLugar = true } = {}) {
    const partes = [];
    const par = (k, v) => partes.push(`${k}=${encodeURIComponent(v)}`);
    const atual = new URLSearchParams(window.location.search);
    // Parâmetros de hoje que a busca leva junto (o servidor os lê; ?estado= é do "Todas as vagas" da página da vaga v1). No
    // hotsite o estado é um filtro (grupo "estado"), que já vai abaixo.
    if (!novaBusca) {
        ['query', 'localidade'].forEach(k => { if (atual.get(k)) par(k, atual.get(k)); });
        if (!D?.hotsite && atual.getAll('estado').length === 1 && atual.get('estado')) par('estado', atual.get('estado'));
    }
    // O escopo fixo do link do hotsite (unidade, divisão) segue em toda troca de filtro e de página.
    if (D?.escopo) {
        partes.push(D.escopo);
    }
    if (S.ponto && manterLugar) {
        partes.push(`perto=${S.ponto.lat},${S.ponto.lon}`);
    }
    G.forEach(g => {
        if (!manterLugar && _gruposDeLugar.includes(g.k)) {
            return;
        }
        if (g.tipo === 'toggle') {
            if (f[g.k]) par(g.k, 'sim');
        } else if (g.tipo === 'radio') {
            if (f[g.k]) par(g.k, f[g.k]);
        } else {
            f[g.k].forEach(v => par(g.k, v));
        }
    });
    if (manterLugar && ouRemotoNaUrl(atual) && f.regiao?.length && f.modalidade?.length) {
        par('ou', 'remoto');
    }
    if (ordem && (manterLugar || ordem !== 'perto')) {
        par('ordem', ordem);
    }
    return partes.join('&');
}

// ---------- barra de filtros (renderFbar): a mesma marcação do _FiltrosV2.cshtml ----------
function rotuloChip(g) {
    if (g.tipo === 'toggle' || !ligado(g)) {
        return g.label;
    }
    if (g.tipo === 'radio') {
        const o = g.ops.find(x => x[0] === S.f[g.k]);
        return o ? o[1].split(' (')[0] : g.label;
    }
    const sel = S.f[g.k];
    if (sel.length === 1) {
        // Na lista cortada (cidades) a escolhida pode não estar nas opções de agora: vale o rótulo que já chegou.
        const o = g.ops.find(x => x[0] === sel[0]);
        return o ? o[1].split(' (')[0] : (_rotulosVistos[`${g.k}:${sel[0]}`] || sel[0]);
    }
    return `${g.label} (${sel.length})`;
}

// "Para você" e depois "Data" são os primeiros chips; filtro em que uma opção domina (≥90%) vai para o fim, exceto "Tipo de vaga"
// e a empresa do hotsite com "Filtrar por empresa" (_FiltrosV2.cshtml).
const ordemChips = () => {
    const total = Math.max(1, D.total);
    const domina = g => g.tipo === 'multi' && !g.fixo && !(D.empresaFiltro && g.k === 'empresa') && g.ops.length && Math.max(...g.ops.map(o => o[2] || 0)) / total >= 0.9;
    const resto = [...G.filter(g => !domina(g)), ...G.filter(domina)];
    const peso = g => (g.k === 'paravoce' ? 0 : g.k === 'data' ? 1 : 2);
    return [...resto].sort((a, b) => peso(a) - peso(b));
};

// O filtro "só de quem entrou" ("Para você") aparece depois do login; ligado, a página já veio pessoal do servidor. No hotsite, o
// filtro que o cliente escondeu e veio ligado no link (oc) só fica enquanto ligado.
const visivel = g => (!g.so || _logado || ligado(g)) && (!g.oc || ligado(g));
const iconeToggle = g => (g.k === 'paravoce' ? 'stars' : g.k === 'selecao' ? 'eye-slash' : 'universal-access-circle');
const textoToggle = g => (g.k === 'paravoce' ? T.paraVoceOpcao : g.k === 'selecao' ? T.selecaoOpcao : T.pcdOpcao);

function desenharBarra() {
    const n = ativos();
    const chip = g => {
        const act = ligado(g);
        if (g.tipo === 'toggle') {
            return `<button class="chip" type="button" data-toggle="${g.k}" aria-pressed="${act}">${ico(act ? 'check-lg' : iconeToggle(g))}${esc(g.label)}${act || g.n == null ? '' : ` <small>${fmt(g.n)}</small>`}</button>`;
        }
        if (act) {
            const r = rotuloChip(g);
            return `<span class="chipset"><button class="chipset__l" type="button" data-facet="${g.k}" aria-haspopup="dialog" aria-expanded="false">${esc(r)}</button><button class="chipset__x" type="button" data-clearfacet="${g.k}" aria-label="${esc(formatar(T.removerFiltro, r))}">${ico('x-lg')}</button></span>`;
        }
        return `<span class="chipwrap chip--sec" style="display:inline-flex;flex:none;max-width:100%"><button class="chip" type="button" data-facet="${g.k}" aria-haspopup="dialog" aria-expanded="false">${esc(g.label)}${ico('chevron-down')}</button></span>`;
    };
    const rotuloOrdem = (ordens().find(o => o[0] === S.ordem) || ordens()[0] || ['', ''])[1];
    const limpar = n >= 2 ? `<button class="chip js-clearall" type="button">${esc(T.limparTudo)}</button>` : '';
    // Hotsite com a ordenação escondida pelo cliente: sem o botão.
    const ordenar = cls => (ordens().length ? `<button class="chip${cls}" type="button" data-facet="__sort" aria-haspopup="dialog">${ico('arrow-down-up')}${esc(rotuloOrdem)}</button>` : '');
    $('fbarIn').innerHTML = `<button class="chip chip--all" type="button" id="btnAll" aria-haspopup="dialog">${ico('sliders')}${esc(T.filtros)}${n ? `<span class="chip__n">${n}</span>` : ''}</button>
    ${ordemChips().filter(g => (!g.sec || ligado(g)) && visivel(g)).map(chip).join('')}
    ${limpar}
    ${ordenar(' fbar__sort')}`;
    $('fbarEnd').innerHTML = limpar + ordenar('');
    requestAnimationFrame(sombrasBarra);
}

function sombrasBarra() {
    const fi = $('fbarIn');
    if (!fi) {
        return;
    }
    $('fbarNext').hidden = fi.scrollLeft + fi.clientWidth >= fi.scrollWidth - 2;
    $('fbarPrev').hidden = fi.scrollLeft <= 2;
}

// ---------- opções de um filtro (optsTpl) ----------
function opcoesHtml(g, origem, aoVivo) {
    if (g.k === '__sort') {
        return `<div style="padding:4px 8px 10px">${ordens().map(([k, l]) => `<label class="opt"><input type="radio" name="sort-${aoVivo ? 'l' : 'd'}" value="${k}" ${origem.ordem === k ? 'checked' : ''} data-sort="1"><span class="opt__l">${esc(l)}</span></label>`).join('')}</div>`;
    }
    if (g.tipo === 'toggle') {
        return `<label class="opt"><input type="checkbox" data-k="${g.k}" ${origem.f[g.k] ? 'checked' : ''}><span class="opt__l">${esc(textoToggle(g))}</span>${g.n == null ? '' : `<span class="opt__n">${fmt(g.n)}</span>`}</label>`;
    }
    if (g.geo && !S.ponto) {
        return geoPerguntaHtml();
    }
    const tipo = g.tipo === 'radio' ? 'radio' : 'checkbox';
    const sel = g.tipo === 'radio' ? [origem.f[g.k]] : origem.f[g.k];
    const todas = g.tipo === 'radio' ? [['', g.vazio || ''], ...g.ops] : g.ops;
    const rotuloBusca = esc(formatar(T.buscarEm, g.label.toLowerCase()));
    return `${g.busca ? `<div class="fsearch">${ico('search')}<input type="search" placeholder="${rotuloBusca}" aria-label="${rotuloBusca}" data-fsearch></div>` : ''}
    ${todas.map(([v, l, q, dica], i) => `<label class="opt ${q === 0 ? 'is-zero' : ''}" ${i >= 6 && g.busca ? 'data-more hidden' : ''}><input type="${tipo}" name="f-${g.k}-${aoVivo ? 'l' : 'd'}" value="${esc(v)}" data-k="${g.k}" ${sel.includes(v) ? 'checked' : ''} ${q === 0 ? 'disabled' : ''}><span class="opt__l">${esc(l)}${dica ? `<small>${esc(dica)}</small>` : ''}</span>${q != null ? `<span class="opt__n">${fmt(q)}</span>` : ''}</label>`).join('')}
    ${g.busca && todas.length > 6 ? `<button class="linkbtn" type="button" data-showmore style="margin:0 8px">${esc(formatar(T.verMais, Math.max(todas.length, g.total || 0) - 6))}</button>` : ''}${g.geo ? geoRodapeHtml() : ''}
    `;
}

// A página traz só as 30 cidades com mais anúncios (o servidor manda o total): a lista inteira vem quando a pessoa abre o
// filtro, com os números da lista na tela, e redesenha as opções abertas sem perder o que já foi digitado na busca do filtro.
const listaCortada = g => g?.total != null && g.ops.length < g.total;

async function completarOpcoes(g) {
    if (!listaCortada(g)) {
        return;
    }
    const antes = g.ops;
    const qs = qsDe(S.f, '');
    let r = null;
    try {
        r = await obterJson(`${D.urlBase}?${qs}${qs ? '&' : ''}parcial=filtro&grupo=${encodeURIComponent(g.k)}`);
    } catch {
        return;
    }
    // A lista trocou enquanto esperava (outro filtro): os números já são outros, fica a lista nova.
    if (!r?.sucesso || !Array.isArray(r.ops) || g.ops !== antes) {
        return;
    }
    g.ops = r.ops;
    g.total = null;
    guardarRotulos(g.k, g.ops);
    redesenharOpcoes(g);
}

function redesenharOpcoes(g) {
    const trocar = (caixa, html) => {
        const busca = caixa.querySelector('[data-fsearch]');
        const texto = busca?.value || '';
        const focada = busca && document.activeElement === busca;
        // A opção marcada agora (o computador aplica a cada toque e redesenha): o foco volta para ela, não cai no body.
        const opcao = !focada && caixa.contains(document.activeElement) ? document.activeElement.closest('input[data-k]') : null;
        const topo = caixa.scrollTop;
        html();
        caixa.scrollTop = topo;
        const nova = caixa.querySelector('[data-fsearch]');
        if (nova && texto) {
            nova.value = texto;
            nova.dispatchEvent(new Event('input', { bubbles: true }));
        }
        if (nova && focada) {
            nova.focus();
        } else if (opcao) {
            const alvo = [...caixa.querySelectorAll(`input[data-k="${opcao.dataset.k}"]`)].find(i => i.value === opcao.value);
            // Voltou escondida ("Ver mais" recolhido) ou sem vagas: a busca do filtro, senão a própria caixa.
            const destino = alvo && !alvo.disabled && !alvo.closest('[hidden]') ? alvo : nova || caixa;
            if (destino === caixa && !caixa.hasAttribute('tabindex')) {
                caixa.setAttribute('tabindex', '-1');
            }
            destino.focus();
        }
    };
    const pop = $('pop');
    if (pop && !pop.hidden && pop.dataset.k === g.k) {
        trocar($('popBody'), () => { $('popBody').innerHTML = opcoesHtml(g, S, true); });
    }
    const facet = $('sheetFacet');
    if (facet && !facet.hidden && facet.dataset.k === g.k && S.rascunho) {
        trocar($('sheetFacetBody'), () => { $('sheetFacetBody').innerHTML = `<div style="padding:8px">${opcoesHtml(g, S.rascunho, false)}</div>`; });
    }
    // Em "Todos os filtros", só o bloco do grupo (o CEP digitado em Distância e o "Ver mais" aberto de outro grupo ficam).
    const bloco = $('sheetFiltros')?.hidden === false && S.rascunho ? document.querySelector(`#sheetFiltrosBody [data-fgroup="${g.k}"]`) : null;
    if (bloco) {
        trocar(bloco, () => { bloco.innerHTML = `<h3>${esc(g.label)}</h3>${opcoesHtml(g, S.rascunho, false)}`; });
    }
}

const geoPerguntaHtml = () => `<div class="geo-ask">
  <p>${esc(T.geoPergunta)}</p>
  <button class="btn btn--navy" type="button" data-geo="gps">${ico('bullseye')}${esc(T.usarLocalizacao)}</button>
  <form class="geo-cep"><label class="fld"><span class="sr">${esc(T.cep)}</span><input inputmode="numeric" autocomplete="postal-code" placeholder="${esc(T.cepPlaceholder)}" maxlength="9"></label><button class="btn btn--out" type="submit">${esc(T.usar)}</button></form>
  <p class="fnote">${esc(T.geoNota)}</p>
</div>`;

// O CEP nunca vai para a URL: só o ponto. Se o ponto da URL veio de um CEP guardado neste aparelho, o texto diz qual.
function origemDoPonto() {
    const salvo = localEscolhido();
    if (salvo?.tipo === 'ponto' && S.ponto && salvo.lat === S.ponto.lat && salvo.lon === S.ponto.lon && salvo.cep) {
        return { de: formatar(T.doCep, salvo.cep), sair: T.naoUsarCep, rotulo: formatar(T.pertoDoCep, salvo.cep), cep: salvo.cep };
    }
    return { de: T.deVoce, sair: T.naoUsarLocalizacao, rotulo: textosBusca.pertoDeVoce, cep: '' };
}

// O título do servidor diz "perto de você"; o do CEP só o aparelho sabe (useGeo da v36).
function mostrarOrigemDoPonto() {
    const o = origemDoPonto();
    if (!o.cep) {
        return;
    }
    if ($('hsL')) $('hsL').value = o.rotulo;
    if ($('mpillL')) $('mpillL').textContent = o.rotulo;
    const resumo = document.querySelector('[data-busca-resumo].is-on .chip__txt');
    // A busca em vigor, e não o rascunho do campo (na carga ela ainda não foi guardada).
    if (resumo) resumo.textContent = [_buscaDaPagina?.q ?? $('hsQ')?.value, o.rotulo].filter(Boolean).join(' · ');
    if ($('resTitle')) $('resTitle').textContent = D.cargo ? formatar(T.tituloPertoCep, D.cargo, o.cep) : formatar(T.tituloPertoCepGeral, o.cep);
    if ($('resDe')) $('resDe').textContent = o.de;
}

const geoRodapeHtml = () => {
    const o = origemDoPonto();
    return `<p class="fnote">${esc(formatar(T.geoRodape, o.de))}</p><button class="linkbtn" type="button" data-geo-off style="margin:0 8px">${esc(o.sair)}</button>`;
};

function lerOpcoes(raiz, alvo) {
    $$('input[data-k]', raiz).forEach(i => {
        const g = GMAP[i.dataset.k];
        if (g.tipo === 'toggle') {
            alvo.f[g.k] = i.checked;
        } else if (g.tipo === 'radio') {
            if (i.checked) alvo.f[g.k] = i.value;
        } else {
            const s = new Set(alvo.f[g.k]);
            i.checked ? s.add(i.value) : s.delete(i.value);
            alvo.f[g.k] = [...s];
        }
    });
    const ordem = raiz.querySelector('input[data-sort]:checked');
    if (ordem) {
        alvo.ordem = ordem.value;
    }
}

// Contagem em anúncios. O número de cada opção conta com os outros filtros aplicados: vale quando só aquele filtro
// muda e fica com uma opção; senão (um anúncio pode estar em duas opções), o servidor conta.
let _contagemControlador = null;
async function estimar(f) {
    // Cancela já a pergunta anterior: uma resposta velha não pode sobrescrever o número de uma estimativa local mais nova.
    _contagemControlador?.abort();
    _contagemControlador = null;
    if (!gruposLigados(f).length) {
        return D.total;
    }
    const mudaram = G.filter(g => JSON.stringify(f[g.k]) !== JSON.stringify(S.f[g.k]));
    if (mudaram.length === 1 && ligado(mudaram[0], f)) {
        const g = mudaram[0];
        if (g.tipo === 'toggle' && g.n != null) return g.n;
        if (g.tipo === 'radio' && g.ops[0]?.[2] != null) return (g.ops.find(o => o[0] === f[g.k]) || [])[2] || 0;
        if (g.tipo === 'multi' && f[g.k].length === 1) return (g.ops.find(o => o[0] === f[g.k][0]) || [])[2] || 0;
    }
    _contagemControlador = new AbortController();
    const sinal = _contagemControlador.signal;
    // Toques seguidos nas opções: só o último vai ao servidor (o anterior é cancelado ainda na espera, sem pedido).
    await new Promise((ok, falha) => {
        const espera = setTimeout(ok, 250);
        sinal.addEventListener('abort', () => {
            clearTimeout(espera);
            falha(new DOMException('', 'AbortError'));
        }, { once: true });
    });
    const qs = qsDe(f, '');
    const r = await obterJson(`${D.urlBase}?${qs}${qs ? '&' : ''}parcial=contagem`, { sinal });
    if (!r?.sucesso) {
        throw new Error('contagem');
    }
    return r.anuncios;
}

async function atualizarBotaoRascunho(sel) {
    const botao = $(sel);
    // Com o cargo ou o local trocados no painel a contagem seria a da busca de antes: o botão fica sem número.
    if (sel === 'allApply' && buscaMudouNoPainel()) {
        _contagemControlador?.abort();
        botao.textContent = T.verVagas;
        return;
    }
    try {
        const n = await estimar(S.rascunho.f);
        botao.textContent = n === 1 ? T.verUmAnuncio : formatar(T.verAnuncios, fmt(n));
    } catch (e) {
        if (e.name !== 'AbortError') {
            botao.textContent = T.verVagas;
        }
    }
}

// ---------- popover (computador) e sheet do filtro (celular) ----------
function abrirFiltro(k, ancora) {
    const g = k === '__sort' ? { k: '__sort', label: T.ordenarPor } : GMAP[k];
    if (!g) {
        return;
    }
    if (!ehCelular()) {
        const pop = $('pop');
        $('popT').textContent = g.label;
        $('popBody').innerHTML = opcoesHtml(g, S, true);
        pop.dataset.k = k;
        S.popEmpilhou = false;
        pop.hidden = false;
        const r = ancora.getBoundingClientRect();
        pop.style.left = Math.max(8, Math.min(r.left, window.innerWidth - pop.offsetWidth - 12)) + 'px';
        pop.style.top = (r.bottom + 6) + 'px';
        ancora.setAttribute('aria-expanded', 'true');
        rodapePop(k);
        pop._ancora = ancora;
        pop.querySelector('input')?.focus();
        completarOpcoes(g);
        return;
    }
    S.rascunho = JSON.parse(JSON.stringify({ f: S.f, ordem: S.ordem }));
    $('sheetFacetT').textContent = g.label;
    $('sheetFacetBody').innerHTML = `<div style="padding:8px">${opcoesHtml(g, S.rascunho, false)}</div>`;
    $('sheetFacet').dataset.k = k;
    // Como o rodapePop do computador: na pergunta de localização não há o que limpar.
    $('facetClear').hidden = !!(g.geo && !S.ponto);
    atualizarBotaoRascunho('facetApply');
    abrirSheet($('sheetFacet'), { marca: 'v2Filtro' });
    completarOpcoes(g);
}

// "Limpar" só onde há o que limpar: some na ordenação e no pedido de localização.
const rodapePop = k => { $('popFoot').hidden = k === '__sort' || (GMAP[k]?.geo && !S.ponto); };

function fecharPop() {
    const p = $('pop');
    if (!p || p.hidden) {
        return false;
    }
    p.hidden = true;
    $$('[data-facet][aria-expanded="true"]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    const k = p.dataset.k;
    setTimeout(() => document.querySelector(`[data-facet="${k}"]`)?.focus(), 0);
    return true;
}

const corpoTodosFiltros = () => (ordens().length ? `<div class="fgroup"><h3>${esc(T.ordenarPor)}</h3><div class="segm" role="group" aria-label="${esc(T.ordenarPor)}">${ordens().map(([k, l]) => `<button type="button" data-dsort="${k}" aria-pressed="${S.rascunho.ordem === k}">${S.rascunho.ordem === k ? ico('check-lg') + ' ' : ''}${esc(l)}</button>`).join('')}</div></div>` : '')
    // Empresa não é filtro de escolher: só aparece enquanto vale a do link (o servidor nem manda o grupo sem ela). No hotsite com
    // "Filtrar por empresa ou unidade", é (v1).
    + G.filter(g => (g.k !== 'empresa' || ligado(g) || D.empresaFiltro) && visivel(g)).map(g => `<div class="fgroup" data-fgroup="${g.k}"><h3>${esc(g.label)}</h3>${opcoesHtml(g, S.rascunho, false)}</div>`).join('');

// ---------- a busca no painel "Filtros" (computador) ----------
// A caixa da faixa vai para o painel enquanto ele está aberto (o mesmo formulário: autocomplete, GPS e ids) e volta quando ele
// some; a faixa guarda a altura para a lista não pular. Fechado sem aplicar, o cargo e o local voltam ao que estava escrito. A
// troca é contra a busca da página: o que foi escrito na faixa sem Buscar também conta.
let _buscaDaPagina = null;
let _buscaAoAbrir = null;
const naGaveta = () => !!$('hsearch')?.closest('#sheetFiltros');
const buscaMudouNoPainel = () => !!_buscaDaPagina && naGaveta()
    && ($('hsQ').value.trim() !== _buscaDaPagina.q.trim() || $('hsL').value.trim() !== _buscaDaPagina.l.trim());

function levarBuscaAoPainel() {
    const form = $('hsearch');
    const faixa = document.querySelector('.fbusca');
    if (!form || !faixa || ehCelular() || naGaveta()) {
        return;
    }
    let caixa = $('sheetBusca');
    if (!caixa) {
        caixa = document.createElement('div');
        caixa.className = 'sheet__busca';
        caixa.id = 'sheetBusca';
        $('sheetFiltrosBody').before(caixa);
        new MutationObserver(() => { if ($('sheetFiltros').hidden) devolverBusca(); }).observe($('sheetFiltros'), { attributes: true, attributeFilter: ['hidden'] });
    }
    faixa.style.height = `${faixa.getBoundingClientRect().height}px`;
    _buscaAoAbrir = { q: $('hsQ').value, l: $('hsL').value };
    caixa.append(form);
}

function devolverBusca() {
    const faixa = document.querySelector('.fbusca');
    if (!faixa || !naGaveta()) {
        return;
    }
    if (_buscaAoAbrir) {
        $('hsQ').value = _buscaAoAbrir.q;
        $('hsL').value = _buscaAoAbrir.l;
    }
    _buscaAoAbrir = null;
    faixa.append($('hsearch'));
    faixa.style.height = '';
}

function abrirTodos() {
    S.rascunho = JSON.parse(JSON.stringify({ f: S.f, ordem: S.ordem }));
    // Voltando do cache do navegador depois de uma busca nova pelo painel, o botão ainda estaria ocupado.
    ocupar($('allApply'), false);
    ocupar($('allClear'), false);
    levarBuscaAoPainel();
    $('sheetFiltrosBody').innerHTML = corpoTodosFiltros();
    atualizarBotaoRascunho('allApply');
    abrirSheet($('sheetFiltros'), { marca: 'v2Filtros' });
    G.filter(listaCortada).forEach(completarOpcoes);
}

// ---------- aplicar: URL nova + o pedaço da lista ----------
let _listaControlador = null;
// filtro_aplicado com os nomes do v1 (data-filtro do vagas.js), para a comparação antes/depois da Fase 0.
const _filtroNoV1 = { paravoce: 'para_voce', regiao: 'cidade', raio: 'raio', tipo: 'regime', data: 'dataPublicacao', pcd: 'pcd', nivel: 'nivel', modalidade: 'modalidade', empresa: 'empresaUnidade' };
const enderecoAtual = () => { const qs = qsDe(); return `${D.urlBase}${qs ? '?' + qs : ''}`; };

// historico: 'push' (filtro novo = entrada no histórico), 'replace' (o mesmo popover de novo ou o Voltar).
// medir: só quando a pessoa aplica um filtro (como o v1); tirar, limpar e voltar não contam.
async function aplicar({ historico = 'push', filtro = '', medir = false } = {}) {
    desenharBarra();
    _maisControlador?.abort();
    _maisControlador = null;
    const endereco = enderecoAtual();
    // No Voltar a lista recomeça na página 1: a URL perde o ?pagina= que a rolagem tinha gravado.
    if (historico === 'push') {
        history.pushState(history.state, '', endereco);
    } else {
        history.replaceState(history.state, '', endereco);
    }
    if (navigator.onLine === false) {
        avisarErro(T.semInternetFiltro);
        $('offline').hidden = false;
        return;
    }
    const col = $('colList');
    const anterior = col.innerHTML;
    const split = document.querySelector('.split');
    const antes = { vazio: split.classList.contains('is-empty'), pane: $('pane').innerHTML, paneOculto: $('paneWrap').hidden };
    // A lista e o painel de antes voltam (sem isto o painel ficava com o esqueleto da vaga para sempre).
    const voltar = () => {
        col.innerHTML = anterior;
        split.classList.toggle('is-empty', antes.vazio);
        $('pane').innerHTML = antes.pane;
        $('paneWrap').hidden = antes.paneOculto;
        observarFimDaLista();
        observarCartoes();
    };
    split.classList.remove('is-empty');
    const more = col.querySelector('.more');
    if (more) more.hidden = true;
    const panorama = $('panorama');
    if (panorama) panorama.hidden = true;
    $('resCount').innerHTML = skLinha('190px', 14);
    $('resList').innerHTML = skCartao().repeat(ehCelular() ? 4 : 5);
    if (!ehCelular()) {
        $('paneWrap').hidden = false;
        $('pane').innerHTML = esqueletoVaga();
    }
    _listaControlador?.abort();
    const controlador = new AbortController();
    _listaControlador = controlador;
    let html;
    try {
        html = await obterHtml(`${endereco}${endereco.includes('?') ? '&' : '?'}parcial=lista`, { sinal: controlador.signal });
    } catch (e) {
        if (e.name === 'AbortError') {
            return;
        }
        if (e instanceof TypeError) {
            // Caiu a conexão no meio: a lista de antes volta e os filtros ficam na URL.
            voltar();
            avisarErro(T.semInternetFiltro);
            $('offline').hidden = false;
            return;
        }
        if (e.name === 'TimeoutError') {
            // Servidor travado: a página inteira esperaria o mesmo servidor; fica a lista de antes.
            voltar();
            avisarErro(T.erroTexto);
            return;
        }
        // Erro do servidor: a página inteira traz o aviso de erro (503, sem cache).
        window.location.href = endereco;
        return;
    }
    trocarLista(html);
    if (medir && filtro !== '__sort') {
        registrarEvento('filtro_aplicado', { filtro: _filtroNoV1[filtro] || 'todos', quantidade_filtros: ativos() });
    }
}

// O sheet de filtro sai do histórico com um Voltar; o filtro entra no histórico só depois dele (senão o Voltar o leva).
let _depoisDoVoltar = null;
function fecharSheetEAplicar(el, opcoes) {
    const volta = !!(el.dataset.marca && history.state?.[el.dataset.marca]);
    if (volta) {
        _depoisDoVoltar = () => aplicar(opcoes);
    }
    fecharSheet(el);
    if (!volta) {
        aplicar(opcoes);
    }
}

function trocarLista(html) {
    const col = $('colList');
    col.innerHTML = html;
    // Os números de cada filtro mudam com os outros filtros: o pedaço da lista traz os novos.
    (lerJson('busca-v2-contagens') || []).forEach(c => {
        if (GMAP[c.k]) {
            GMAP[c.k].ops = c.ops;
            GMAP[c.k].n = c.n;
            GMAP[c.k].total = c.total;
            guardarRotulos(c.k, c.ops);
            // O filtro aberto (popover ou painel do celular) segue com a lista inteira, com os números novos.
            const pop = $('pop');
            const sheet = $('sheetFacet');
            const aberto = (pop && !pop.hidden && pop.dataset.k === c.k) || (sheet && !sheet.hidden && sheet.dataset.k === c.k);
            if (aberto && listaCortada(GMAP[c.k])) {
                completarOpcoes(GMAP[c.k]);
            }
        }
    });
    // O servidor só liga o "Para você" para candidato com a sessão valendo: se a lista veio sem ele, o chip e a URL voltam.
    if (S.f.paravoce && !new URLSearchParams($('resList')?.dataset.qs || '').has('paravoce')) {
        S.f.paravoce = false;
        desenharBarra();
        const qs = qsDe();
        history.replaceState(history.state, '', `${D.urlBase}${qs ? `?${qs}` : ''}`);
    }
    const pcdN = document.querySelector('#fbarIn [data-toggle="pcd"] small');
    if (pcdN && GMAP.pcd) {
        pcdN.textContent = fmt(GMAP.pcd.n || 0);
    }
    _paginaInicial = +($('resList')?.dataset.pagina || 1);
    if (S.ponto) {
        mostrarOrigemDoPonto();
    }
    const lista = $('resList');
    const vazio = !lista.querySelector('.card[data-id]:not(.card--sk)') || !!lista.querySelector('.empty');
    document.querySelector('.split').classList.toggle('is-empty', vazio);
    $('paneWrap').hidden = vazio;
    if (vazio) {
        $('pane').innerHTML = '';
        medirSemResultado();
    }
    depoisDaLista();
    desenharAlerta();
    if (!ehCelular() && !vazio) {
        const primeiro = idsDaLista()[0];
        if (primeiro) {
            selecionarNoPainel(primeiro, { doUsuario: false });
        }
    }
    col.scrollTop = 0;
    if (ehCelular()) {
        window.scrollTo({ top: 0 });
    }
}

const idsDaLista = () => $$('#resList > .card[data-id]').map(c => +c.dataset.id);
const medirSemResultado = () => {
    if (+($('resList')?.dataset.pagina || 1) === 1 && !$('resList')?.dataset.erro) {
        registrarEvento('busca_sem_resultado', { termo: (D.query || '').slice(0, 100), local: (D.localNome || '').slice(0, 100), quantidade_filtros: ativos() });
    }
};
// A lista pode começar numa página N (?pagina=N): a posição da vaga conta as páginas de antes.
let _paginaInicial = +($('resList')?.dataset.pagina || 1);
const totalAnuncios = () => +($('resList')?.dataset.anuncios || 0);
const posicaoDaVaga = id => (_paginaInicial - 1) * (D?.itens || 10) + idsDaLista().indexOf(id) + 1;

function depoisDaLista() {
    remarcarCartoes(_enviadas);
    observarFimDaLista();
    observarCartoes();
    marcarEnviadasDaPagina();
    sizeVars();
}

// O Voltar entre as vagas do painel do computador (cada vaga escolhida é uma entrada): a do endereço, ou a primeira da lista
// quando ele não tem (a chegada). No celular o Voltar fecha o sheet da vaga.
const vagaDoEndereco = () => {
    if (!ehCelular() && $('pane')) {
        mostrarVagaDoHistorico(+new URLSearchParams(window.location.search).get('vaga') || idsDaLista()[0]);
    }
};

window.addEventListener('popstate', () => {
    if (!D) {
        vagaDoEndereco();
        return;
    }
    if (_depoisDoVoltar) {
        const funcao = _depoisDoVoltar;
        _depoisDoVoltar = null;
        funcao();
        return;
    }
    // Voltar de um filtro: a URL mudou (sem contar vaga e página) e a lista volta a ser a daquela URL.
    const atual = chaveDaUrl(window.location.search);
    if (atual === chaveDaUrl(qsDe())) {
        vagaDoEndereco();
        return;
    }
    if (atual === _chegada.chave) {
        // A URL de chegada pode estar no formato de hoje (?empresaUnidade=, utm_*): vale o estado que o servidor leu dela.
        if (JSON.stringify(S.f) === JSON.stringify(_chegada.f) && S.ordem === _chegada.ordem) {
            return;
        }
        S.f = JSON.parse(JSON.stringify(_chegada.f));
        S.ordem = _chegada.ordem;
    } else {
        const p = new URLSearchParams(window.location.search);
        S.f = vazioF();
        G.forEach(g => {
            const v = p.getAll(g.k);
            // Na lista cortada (cidades), o código que não veio pode existir: o servidor confere.
            S.f[g.k] = g.tipo === 'multi' ? v.filter(x => listaCortada(g) || g.ops.some(o => o[0] === x)) : g.tipo === 'toggle' ? v.includes('sim') : (v[0] || '');
        });
        S.ordem = p.get('ordem') || '';
    }
    fecharPop();
    aplicar({ historico: 'replace' });
});

// ---------- rolagem infinita: o link real "Próxima página" vira o gatilho ----------
let _carregando = false;
let _observadorFim = null;
let _maisControlador = null;
async function carregarMais() {
    const a = $('loadMore');
    if (_carregando || !a || a.hidden || !a.getAttribute('href')) {
        return false;
    }
    _carregando = true;
    const controlador = new AbortController();
    _maisControlador = controlador;
    $('resList').insertAdjacentHTML('beforeend', skCartao().repeat(3));
    let html;
    try {
        html = await obterHtml(`${a.getAttribute('href')}&parcial=lista`, { sinal: controlador.signal });
    } catch {
        // Cancelado por um filtro novo: a lista já é outra (e o esqueleto foi junto).
        if (_maisControlador === controlador) {
            $$('#resList > .card--sk').forEach(c => c.remove());
            // Sem o aviso a lista só parava de crescer; o link "Próxima página" (a página inteira) continua.
            avisarErro(navigator.onLine === false ? T.semInternetFiltro : T.erroTexto);
        }
        _carregando = false;
        return false;
    }
    if (_maisControlador !== controlador || !a.isConnected) {
        _carregando = false;
        return false;
    }
    const modelo = document.createElement('template');
    modelo.innerHTML = html;
    $$('#resList > .card--sk').forEach(c => c.remove());
    const lista = $('resList');
    modelo.content.querySelectorAll('#resList > .card[data-id]').forEach(c => lista.append(c));
    const novoLink = modelo.content.getElementById('loadMore');
    const novoFim = modelo.content.getElementById('moreEnd');
    const pagina = modelo.content.getElementById('resList')?.dataset.pagina;
    if (novoLink) {
        novoLink.getAttribute('href') ? a.setAttribute('href', novoLink.getAttribute('href')) : a.removeAttribute('href');
        a.hidden = novoLink.hidden;
    }
    if (novoFim) {
        $('moreEnd').hidden = novoFim.hidden;
        $('moreEnd').textContent = novoFim.textContent;
    }
    if (pagina) {
        lista.dataset.pagina = pagina;
    }
    _carregando = false;
    depoisDaLista();
    return true;
}

function observarFimDaLista() {
    _observadorFim?.disconnect();
    const a = $('loadMore');
    if (!a || !('IntersectionObserver' in window)) {
        return;
    }
    // No celular rola a página; no computador, só a coluna da lista.
    _observadorFim = new IntersectionObserver(es => {
        if (es.some(x => x.isIntersecting)) {
            carregarMais();
        }
    }, { root: ehCelular() ? null : $('colList'), rootMargin: '0px 0px 600px 0px' });
    _observadorFim.observe(a);
}

// Prefetch do corpo: hover no computador; no celular, card parado na tela por um instante (no máximo 2 de cada vez).
let _observadorCartoes = null;
const _esperas = new Map();
function observarCartoes() {
    if (!ehCelular() || !('IntersectionObserver' in window)) {
        return;
    }
    _observadorCartoes?.disconnect();
    _observadorCartoes = new IntersectionObserver(es => es.forEach(x => {
        const id = +x.target.dataset.id;
        if (x.isIntersecting) {
            _esperas.set(id, setTimeout(() => { if (_esperas.size <= 2) prefetch(id); _esperas.delete(id); }, 400));
        } else {
            clearTimeout(_esperas.get(id));
            _esperas.delete(id);
        }
    }), { threshold: 0.6 });
    $$('#resList > .card[data-id]').forEach(c => _observadorCartoes.observe(c));
}

// ---------- logado: candidaturas desta página e o alerta da busca ----------
let _enviadas = [];
let _logado = false;
async function marcarEnviadasDaPagina() {
    if (!_logado) {
        return;
    }
    const ids = idsDaLista();
    if (!ids.length) {
        return;
    }
    try {
        const r = await obterJson(url(`/Vagas/CandidaturasDaListaV2?ids=${ids.join(',')}`), { semCache: true });
        _enviadas = [...new Set([..._enviadas, ...(r?.ids || [])])];
        remarcarCartoes(_enviadas);
    } catch {
        // Sem a marca no card; o painel ainda mostra pelo BotaoCandidatar.
    }
}

// O alerta que tem o cargo desta busca (AlertaDaBuscaV2) e se ele cobre a cidade dela.
let _alertaDaBusca = null;
let _abrindoAlerta = false;
const _cargoDoAlerta = () => (D?.alertaNaBusca ? D.cargo || D.query : '');
function desenharAlerta() {
    const a = $('alertBtn');
    if (!a || !_logado) {
        return;
    }
    $$('#alertBtn, .js-alert').forEach(b => b.setAttribute('aria-haspopup', 'dialog'));
    const al = _alertaDaBusca?.cobre ? _alertaDaBusca.alerta : null;
    a.classList.toggle('is-on', !!al && !al.pausado);
    // Pausado não manda e-mail: aparece desligado.
    a.innerHTML = al
        ? `${ico(al.pausado ? 'bell' : 'bell-fill')}${esc(T.alertaBusca)} <span class="st">${esc(al.pausado ? T.alertaDesligado : T.alertaLigado)}</span>`
        : `${ico('bell')}<span class="al-d">${esc(T.criarAlerta)}</span><span class="al-m">${esc(T.alerta)}</span>`;
}

async function carregarAlerta() {
    try {
        _alertaDaBusca = await obterAlertaDaBusca(_cargoDoAlerta(), D.localAlerta || '');
    } catch {
        _alertaDaBusca = null;
    }
    desenharAlerta();
}

// Todos os botões de alerta da busca (o do contador, o "Criar alerta" da lista e o "Avise-me" do vazio) abrem a janela já
// preenchida: o alerta que já tem o cargo, para editar, ou um novo com o cargo e a cidade da busca.
async function abrirAlerta(botao) {
    const cargo = _cargoDoAlerta();
    if (!cargo || _abrindoAlerta) {
        return;
    }
    // Um toque de cada vez (o segundo, antes de a janela abrir, a abriria de novo).
    _abrindoAlerta = true;
    ocupar(botao);
    let saindo = false;
    // Volta do login já abrindo a janela (?alerta=1).
    const irAoLogin = () => {
        saindo = true;
        const p = new URLSearchParams(window.location.search);
        p.set('alerta', '1');
        window.location.href = url(`/login?ReturnUrl=${encodeURIComponent(`${window.location.pathname}?${p}`)}`);
    };
    try {
        // O clique pode vir antes de o GetUsuarioLogado responder: quem está logado não vai para o login.
        _logado = !!(await obterUsuario())?.logado;
        if (!_logado) {
            irAoLogin();
            return;
        }
        const abriu = await abrirAlertaDaBusca(cargo, D.localAlerta || '', {
            gatilho: botao,
            aoMudar: ({ novo }) => {
                if (novo) {
                    registrarEvento('alerta_criado', { origem: 'busca' });
                }
                carregarAlerta();
            }
        });
        if (!abriu) {
            irAoLogin();
        }
    } catch {
        avisarErro(T.erroAlerta);
    } finally {
        _abrindoAlerta = false;
        if (!saindo) {
            ocupar(botao, false);
        }
    }
}

async function iniciarLogado() {
    const u = await obterUsuario();
    _logado = !!u?.logado;
    // Hotsite sem vagas: quem entrou vê "Revisar currículo" no lugar do convite para o cadastro (a página é a mesma para todos).
    if (_logado) {
        $$('[data-hs-visitante]').forEach(x => { x.hidden = true; });
        $$('[data-hs-logado]').forEach(x => { x.hidden = false; });
    }
    // Visitante que tocou em "Avise-me" no autocomplete: o login, voltando aqui com a janela aberta (sem resposta do servidor, não).
    if (!_logado && !u?.erro && _alertaNaChegada && _cargoDoAlerta()) {
        abrirAlerta(null);
        return;
    }
    if (!_logado || !D) {
        // Vagas salvas: os cards podem chegar antes do usuário (o depoisDaLista deles achou _logado falso); as marcas entram agora.
        if (_logado && modoSalvas) {
            marcarEnviadasDaPagina();
        }
        return;
    }
    // O chip "Para você" (só de quem entrou): a barra é redesenhada com ele (a página veio igual para todos, com ele escondido).
    desenharBarra();
    marcarEnviadasDaPagina();
    if (_cargoDoAlerta()) {
        await carregarAlerta();
        if (_alertaNaChegada) {
            abrirAlerta($('alertBtn'));
        }
    }
}

// ---------- perto de você ----------
// O ponto muda a busca da landing (contagens por distância, título): a página vem inteira do servidor.
// Escolhido dentro do sheet de filtros, leva junto o que a pessoa já marcou ali.
function irComPonto(ponto) {
    if (!D) {
        return;
    }
    const emSheet = S.rascunho && ($('sheetFacet')?.classList.contains('is-open') || $('sheetFiltros')?.classList.contains('is-open'));
    const alvo = emSheet ? S.rascunho : S;
    S.ponto = ponto;
    if (ponto && !alvo.f.raio) {
        alvo.f.raio = '10';
    }
    if (!ponto) {
        alvo.f.raio = '';
        if (alvo.ordem === 'perto') alvo.ordem = '';
    }
    const qs = qsDe(alvo.f, alvo.ordem);
    irPara(`${D.urlBase}${qs ? '?' + qs : ''}`);
}

async function usarLocalizacao() {
    try {
        const ponto = await pedirLocalizacao();
        escolherLocal({ tipo: 'ponto', origem: 'aparelho', nome: textosBusca.pertoDeVoce, ...ponto, cidade: localDaConexao()?.nome || '' });
        if (D) {
            irComPonto(ponto);
            return;
        }
        // Nas vagas salvas não há busca para filtrar: vai para a busca geral perto do ponto. Sem fechar a busca em tela cheia
        // antes: o irPara troca a entrada dela (fechar faria um back() junto com a ida).
        irPara(`${url('/vagas')}?perto=${ponto.lat},${ponto.lon}&raio=10`);
    } catch {
        avisarErro(textosBusca.localizacaoNegada || T.localizacaoNegada);
    }
}

async function usarCep(texto) {
    const cep = (texto || '').replace(/\D/g, '');
    if (cep.length !== 8) {
        avisarErro(T.cepInvalido);
        return;
    }
    try {
        const r = await obterJson(urlApi(`/variaveis/cidades/coordenada-cep?cep=${cep}`));
        if (!r?.sucesso) {
            avisarErro(T.cepNaoEncontrado);
            return;
        }
        const ponto = { lat: r.lat, lon: r.lon };
        escolherLocal({ tipo: 'ponto', origem: 'cep', cep: `${cep.slice(0, 5)}-${cep.slice(5)}`, nome: textosBusca.pertoDeVoce, ...ponto, cidade: r.cidade ? `${r.cidade}, ${r.uf}` : '' });
        irComPonto(ponto);
    } catch {
        avisarErro(T.cepNaoEncontrado);
    }
}

// ---------- nova busca (topo, tela cheia) ----------
const _textoDoLocalAtual = () => (S.ponto ? origemDoPonto().rotulo : (D?.localNome || ''));

function localDoTexto(texto) {
    texto = (texto || '').trim();
    if (!texto) {
        return null;
    }
    if (S.ponto && texto === origemDoPonto().rotulo) {
        const salvo = localEscolhido();
        return salvo?.cidade ? { nome: salvo.cidade, slug: slugDoLocal(salvo.cidade) } : null;
    }
    if (D && texto === D.localNome) {
        return { nome: D.localNome, slug: D.localSlug || slugDoLocal(D.localNome) };
    }
    return { nome: texto, slug: slugDoLocal(texto) };
}

// rascunho: do painel "Filtros", com o cargo ou o local trocados lá; os filtros escolhidos vão junto (os de lugar só com o
// mesmo local).
function buscar(cargo, textoLocal, rascunho = null) {
    const comPonto = S.ponto && (textoLocal || '').trim() === origemDoPonto().rotulo;
    const local = comPonto ? null : localDoTexto(textoLocal);
    guardarBuscaRecente(cargo, local?.nome || '');
    const destino = urlBusca(cargo, local);
    let qs = comPonto ? `perto=${S.ponto.lat},${S.ponto.lon}&raio=${S.f.raio || 10}` : '';
    if (rascunho) {
        const manterLugar = comPonto || (textoLocal || '').trim() === (_buscaDaPagina?.l || '').trim();
        const f = { ...rascunho.f, raio: comPonto ? rascunho.f.raio || '10' : rascunho.f.raio };
        qs = qsDe(f, rascunho.ordem, { novaBusca: true, manterLugar });
    }
    irPara(qs ? `${destino}${destino.includes('?') ? '&' : '?'}${qs}` : destino);
}

// ---------- medidas do layout de duas colunas ----------
// Lidas no próximo quadro, uma vez por quadro: logo depois das escritas da montagem, a leitura forçava um layout a mais no meio do script.
let _medidasPendentes = false;
function sizeVars() {
    if (_medidasPendentes) {
        return;
    }
    _medidasPendentes = true;
    requestAnimationFrame(() => {
        _medidasPendentes = false;
        const raiz = document.documentElement;
        const w = $('paneWrap');
        if (w) {
            raiz.style.setProperty('--sbw', (w.offsetWidth - w.clientWidth) + 'px');
        }
        const fb = $('fbar');
        if (fb && fb.offsetParent) {
            raiz.style.setProperty('--pane-top', Math.round(fb.getBoundingClientRect().bottom + 24) + 'px');
        }
    });
}

// Computador: rolando a lista ou a vaga, a faixa da busca se recolhe (pedido do dono); volta com as duas colunas no topo. Os
// campos ficam também no painel "Filtros". Coluna com pouca rolagem não recolhe: crescendo, ela voltaria ao topo e abriria de novo.
function iniciarBuscaRecolhida() {
    const faixa = document.querySelector('.fbusca');
    const colunas = [$('colList'), $('paneWrap')].filter(Boolean);
    if (!faixa || !colunas.length) {
        return;
    }
    let agendado = false;
    // Só a rolagem da pessoa recolhe: a do link ?vaga= (o scrollIntoView da carga) deixa a faixa aberta.
    let daPessoa = false;
    ['wheel', 'pointerdown', 'keydown', 'touchstart'].forEach(tipo => window.addEventListener(tipo, () => { daPessoa = true; }, { once: true, passive: true }));
    const recolher = sim => {
        if (faixa.classList.contains('is-min') !== sim) {
            // O popover do filtro fica no lugar do chip, e a barra sobe ou desce com a faixa; o chip da busca muda a largura dos
            // filtros (as setas de rolar).
            fecharPop();
            faixa.classList.toggle('is-min', sim);
            requestAnimationFrame(sombrasBarra);
        }
    };
    const medir = () => {
        agendado = false;
        if (!daPessoa || ehCelular() || faixa.contains(document.activeElement)) {
            return;
        }
        if (colunas.some(c => c.scrollTop > 24 && c.scrollHeight - c.clientHeight > 160)) {
            recolher(true);
        } else if (colunas.every(c => c.scrollTop <= 4)) {
            recolher(false);
        }
    };
    colunas.forEach(c => c.addEventListener('scroll', () => {
        if (!agendado) {
            agendado = true;
            requestAnimationFrame(medir);
        }
    }, { passive: true }));
}

// Celular: o topo rola com a página e leva a pílula da busca; fora da tela, a barra presa no alto mostra o chip da busca.
function iniciarChipDaBuscaNoCelular() {
    const topo = document.querySelector('.site-h');
    const barra = $('fbar');
    if (!topo || !barra || !('IntersectionObserver' in window)) {
        return;
    }
    // A última entrada: numa rolagem rápida de ida e volta o lote traz as duas, e a primeira já está velha.
    new IntersectionObserver(es => {
        const x = es[es.length - 1];
        if (barra.classList.contains('is-preso') === x.isIntersecting) {
            barra.classList.toggle('is-preso', !x.isIntersecting);
            requestAnimationFrame(sombrasBarra);
        }
    }).observe(topo);
}

// Computador: em cima do topo e da barra de filtros (fora das colunas), a roda rola a coluna do mesmo lado.
function repassaRoda(e) {
    if (ehCelular() || e.ctrlKey || Math.abs(e.deltaY) <= Math.abs(e.deltaX)) {
        return;
    }
    const col = $('colList');
    const wrap = $('paneWrap');
    const alvo = !wrap?.offsetParent || e.clientX < col.getBoundingClientRect().right ? col : wrap;
    e.preventDefault();
    alvo.scrollBy({ top: e.deltaY * (e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? alvo.clientHeight : 1), behavior: 'instant' });
}

// ---------- vagas salvas ----------
let _salvasN = 0;
let _salvasEncerradas = 0;
// A lista da conta pode refazer a página enquanto a 1ª carga ainda espera os cards: só a mais recente desenha.
let _salvasCarga = 0;

// "N vagas salvas neste aparelho" ou, de quem entrou, "na sua conta, em qualquer aparelho".
function _contagemSalvas() {
    const contagem = $('resCount');
    if (!_salvasN) {
        return;
    }
    const conta = salvasNaConta() && T.salvasContagemConta;
    contagem.textContent = _salvasN === 1 ? (conta ? T.salvasContagemContaUma : T.salvasContagemUma) : formatar(conta ? T.salvasContagemConta : T.salvasContagem, fmt(_salvasN));
    if (_salvasEncerradas > 0) {
        contagem.textContent += ` · ${formatar(T.salvasEncerradas, fmt(_salvasEncerradas))}`;
    }
}

async function iniciarSalvas() {
    const carga = ++_salvasCarga;
    _salvasN = 0;
    const ids = vagasSalvas();
    const lista = $('resList');
    const contagem = $('resCount');
    const vazio = () => {
        lista.innerHTML = `<li class="empty"><span class="empty__ic" aria-hidden="true">${ico('bookmark')}</span><h2>${esc(T.salvasVazioTitulo)}</h2><p>${esc(T.salvasVazioTexto)}</p><div class="empty__acts"><a class="btn btn--pri" href="${url('/vagas')}">${esc(T.buscarVagas)}</a></div></li>`;
        contagem.textContent = '';
        document.querySelector('.split').classList.add('is-empty');
        $('paneWrap').hidden = true;
        lista.removeAttribute('aria-busy');
    };
    if (!ids.length) {
        vazio();
        return;
    }
    lista.innerHTML = skCartao().repeat(Math.min(ids.length, ehCelular() ? 4 : 5));
    let html = '';
    try {
        html = await obterHtml(url(`/vagas-salvas?parcial=cards&ids=${ids.join(',')}`));
    } catch {
        if (carga !== _salvasCarga) {
            return;
        }
        lista.innerHTML = `<li class="empty"><h2>${esc(T.erroTitulo)}</h2><p>${esc(T.erroTexto)}</p><div class="empty__acts"><button class="btn btn--pri" type="button" data-recarregar>${esc(T.tentarDeNovo)}</button></div></li>`;
        lista.removeAttribute('aria-busy');
        return;
    }
    if (carga !== _salvasCarga) {
        return;
    }
    lista.innerHTML = html;
    lista.removeAttribute('aria-busy');
    const achadas = idsDaLista();
    if (!achadas.length) {
        vazio();
        return;
    }
    _salvasN = achadas.length;
    _salvasEncerradas = ids.length - _salvasN;
    _contagemSalvas();
    lista.dataset.anuncios = _salvasN;
    // A página pode ter passado pelo vazio antes de a lista da conta chegar.
    document.querySelector('.split').classList.remove('is-empty');
    $('paneWrap').hidden = false;
    depoisDaLista();
    // A volta do login ou do currículo (?vaga=): a salva que a pessoa estava vendo abre de novo (e o envio sai, ?confirmar=1).
    const daVolta = +new URLSearchParams(window.location.search).get('vaga');
    const alvo = achadas.includes(daVolta) ? daVolta : 0;
    if (!ehCelular()) {
        selecionarNoPainel(alvo || achadas[0], { doUsuario: false, visualizar: !!alvo });
    } else if (alvo) {
        history.replaceState(history.state, '', (() => { const u = new URL(window.location.href); u.searchParams.delete('vaga'); return u.pathname + u.search; })());
        abrirNoSheet(alvo);
    }
}


// ---------- eventos ----------
function iniciarEventos() {
    document.addEventListener('click', e => {
        const t = e.target;

        // a vaga do card abre no painel (computador) ou no sheet (celular); Ctrl/Cmd+clique abre a página em outra aba
        const card = t.closest('#resList > .card a[data-vaga]');
        if (card && cliqueComum(e)) {
            e.preventDefault();
            const id = +card.dataset.vaga;
            if (ehCelular()) {
                abrirNoSheet(id);
            } else {
                selecionarNoPainel(id, { focar: e.detail === 0 });
            }
            return;
        }

        // O chip da busca (faixa recolhida) abre a faixa no campo do cargo, depois da animação (a lista de sugestões mede o campo).
        if (t.closest('[data-busca-resumo]')) {
            fecharPop();
            // No celular não há a faixa: o chip abre a busca em tela cheia, como a pílula do topo.
            if (ehCelular()) {
                abrirSov('Q', t.closest('[data-busca-resumo]'));
                return;
            }
            document.querySelector('.fbusca')?.classList.remove('is-min');
            requestAnimationFrame(sombrasBarra);
            // No hotsite sem o "O quê", o campo do local (o que estiver na tela).
            setTimeout(() => [$('hsQ'), $('hsL')].find(c => c?.offsetParent)?.focus(), 220);
            return;
        }
        const sov = t.closest('[data-sov]');
        if (sov && cliqueComum(e)) {
            e.preventDefault();
            // No computador a caixa da busca já está na tela, em cima dos filtros (como na home): o foco vai para ela, com o texto selecionado. No
            // hotsite o pedido pode estar escondido (FiltrosVisiveis): vale o outro.
            const campo = !ehCelular() && [$(sov.dataset.sov === 'L' ? 'hsL' : 'hsQ'), $('hsL'), $('hsQ')].find(c => c?.offsetParent);
            if (campo) {
                document.querySelector('.fbusca')?.classList.remove('is-min');
                requestAnimationFrame(() => { campo.focus(); campo.select(); });
                return;
            }
            abrirSov(sov.dataset.sov);
            return;
        }
        // Na busca, "Buscar" da barra inferior abre a busca em tela cheia (v36). No hotsite sem o "O quê" e sem o "Onde" ela
        // abriria sem campo nenhum: o link segue.
        const semCampos = document.body.classList.contains('hs-sem-cargo') && document.body.classList.contains('hs-sem-local');
        if (D && !semCampos && t.closest('.bnav [data-bn="busca"]') && cliqueComum(e)) {
            e.preventDefault();
            abrirSov('Q');
            return;
        }

        const geo = t.closest('[data-geo]');
        if (geo && !geo.closest('#sov')) {
            e.preventDefault();
            usarLocalizacao();
            return;
        }
        if (t.closest('[data-geo-off]')) {
            escolherLocal(null);
            irComPonto(null);
            return;
        }

        // Nas vagas salvas o "Tentar de novo" refaz só os cards, não a página.
        if (t.closest('[data-recarregar]') || (modoSalvas && t.closest('#retry'))) {
            $('offline')?.setAttribute('hidden', '');
            modoSalvas ? iniciarSalvas() : window.location.reload();
            return;
        }
        if (t.closest('[data-pv-x]')) {
            // Sem o aviso, o foco vai para o título (o botão some).
            t.closest('[data-pv-aviso]')?.remove();
            $('resTitle')?.focus();
            return;
        }
        // Sem a busca (vagas salvas, vagas para você) não há o que reaplicar: a página recarrega.
        if (!D && t.closest('#retry')) {
            window.location.reload();
            return;
        }
        if (!D) {
            return;
        }
        const seta = t.closest('#fbarNext, #fbarPrev');
        if (seta) {
            const fi = $('fbarIn');
            fi.scrollBy({ left: (seta.id === 'fbarNext' ? 1 : -1) * Math.max(120, fi.clientWidth * 0.7), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
            return;
        }
        if (t.closest('#btnAll')) {
            fecharPop();
            abrirTodos();
            return;
        }
        // Fora do popover ele fecha, como em qualquer outro clique (aberto, ficaria com as caixas de antes).
        const limpar = t.closest('[data-clearfacet]');
        if (limpar) {
            const g = GMAP[limpar.dataset.clearfacet];
            fecharPop();
            S.f[g.k] = g.tipo === 'multi' ? [] : g.tipo === 'toggle' ? false : '';
            aplicar({ filtro: g.k });
            return;
        }
        const chip = t.closest('[data-facet]');
        if (chip) {
            const k = chip.dataset.facet;
            if (!$('pop').hidden && $('pop').dataset.k === k) {
                fecharPop();
                return;
            }
            fecharPop();
            abrirFiltro(k, chip);
            return;
        }
        const alternar = t.closest('[data-toggle]');
        if (alternar) {
            fecharPop();
            S.f[alternar.dataset.toggle] = !S.f[alternar.dataset.toggle];
            aplicar({ filtro: alternar.dataset.toggle, medir: S.f[alternar.dataset.toggle] });
            return;
        }
        const atalho = t.closest('[data-quick]');
        if (atalho) {
            const [k, v] = atalho.dataset.quick.split('|');
            const g = GMAP[k];
            if (g) {
                fecharPop();
                if (g.tipo === 'radio') S.f[k] = v;
                else S.f[k] = [...new Set([...S.f[k], v])];
                aplicar({ filtro: k, medir: true });
            }
            return;
        }
        if (t.closest('.js-clearall') || t.closest('#emptyClear')) {
            fecharPop();
            S.f = vazioF();
            aplicar({ filtro: 'limpar' });
            return;
        }
        if (t.closest('#popClose')) {
            fecharPop();
            return;
        }
        if (t.closest('#popClear')) {
            const k = $('pop').dataset.k;
            const g = GMAP[k];
            if (g) {
                S.f[k] = g.tipo === 'toggle' ? false : g.tipo === 'radio' ? '' : [];
                aplicar({ filtro: k });
                $('popBody').innerHTML = opcoesHtml(g, S, true);
                completarOpcoes(g);
            }
            return;
        }
        const verMais = t.closest('[data-showmore]');
        if (verMais) {
            $$('[data-more]', verMais.parentElement).forEach(x => x.removeAttribute('hidden'));
            verMais.remove();
            return;
        }
        const ordemRascunho = t.closest('[data-dsort]');
        if (ordemRascunho) {
            S.rascunho.ordem = ordemRascunho.dataset.dsort;
            const corpo = $('sheetFiltrosBody');
            const topo = corpo.scrollTop;
            corpo.innerHTML = corpoTodosFiltros();
            corpo.scrollTop = topo;
            atualizarBotaoRascunho('allApply');
            return;
        }
        const limparFiltro = t.closest('#facetClear');
        if (limparFiltro || t.closest('#facetApply')) {
            const el = $('sheetFacet');
            const k = el.dataset.k;
            // "Limpar" desmarca e já aplica, como o "Ver N anúncios". Sem mudança (nada para limpar), os dois só fecham:
            // refazer a mesma lista a levaria ao topo e deixaria um Voltar a mais.
            if (limparFiltro) {
                const g = GMAP[k];
                if (k === '__sort') {
                    S.rascunho.ordem = '';
                } else if (g) {
                    S.rascunho.f[k] = g.tipo === 'toggle' ? false : g.tipo === 'radio' ? '' : [];
                }
            }
            if (qsDe(S.rascunho.f, S.rascunho.ordem) === qsDe()) {
                fecharSheet(el);
            } else {
                S.f = S.rascunho.f;
                S.ordem = S.rascunho.ordem;
                fecharSheetEAplicar(el, { filtro: k, medir: !limparFiltro });
            }
            setTimeout(() => (document.querySelector(`[data-facet="${k}"]`) || document.querySelector(`[data-toggle="${k}"]`) || $('btnAll'))?.focus(), 300);
            return;
        }
        if (t.closest('#allApply')) {
            // Cargo ou local trocados no painel: é uma busca nova, com os filtros escolhidos.
            if (buscaMudouNoPainel()) {
                if (ocupado($('allApply'))) {
                    return;
                }
                ocupar($('allApply'));
                buscar($('hsQ').value, $('hsL').value, S.rascunho);
                return;
            }
            S.f = S.rascunho.f;
            S.ordem = S.rascunho.ordem;
            _buscaAoAbrir = null;
            fecharSheetEAplicar($('sheetFiltros'), { filtro: 'todos', medir: true });
            return;
        }
        // "Limpar tudo" limpa e já aplica, como o "Limpar" de cada filtro: sem nada para limpar, só fecha.
        if (t.closest('#allClear')) {
            S.rascunho.f = vazioF();
            if (buscaMudouNoPainel()) {
                if (ocupado($('allClear'))) {
                    return;
                }
                ocupar($('allClear'));
                buscar($('hsQ').value, $('hsL').value, S.rascunho);
                return;
            }
            if (qsDe(S.rascunho.f, S.rascunho.ordem) === qsDe()) {
                fecharSheet($('sheetFiltros'));
                return;
            }
            S.f = S.rascunho.f;
            S.ordem = S.rascunho.ordem;
            _buscaAoAbrir = null;
            fecharSheetEAplicar($('sheetFiltros'), { filtro: 'limpar' });
            return;
        }
        if (t.closest('#sheetFacet [data-close], #sheetFiltros [data-close], #sheetFacet .sheet__grab, #sheetFiltros .sheet__grab')) {
            fecharSheet(t.closest('.sheet'));
            return;
        }
        const alerta = t.closest('#alertBtn, .js-alert');
        if (alerta) {
            abrirAlerta(alerta);
            return;
        }
        if (t.closest('#retry')) {
            $('offline').hidden = true;
            aplicar({ historico: 'replace' });
            return;
        }
        if (!t.closest('#pop') && !$('pop').hidden) {
            fecharPop();
        }
    });

    document.addEventListener('change', e => {
        const i = e.target;
        if (!D || i.closest('.geo-cep')) {
            return;
        }
        if (i.closest('#popBody')) {
            const k = $('pop').dataset.k;
            if (i.dataset.sort) {
                S.ordem = i.value;
            } else {
                lerOpcoes($('popBody'), S);
            }
            // Uma entrada no histórico por popover, não por clique.
            aplicar({ historico: S.popEmpilhou ? 'replace' : 'push', filtro: k, medir: i.checked && !i.dataset.sort });
            S.popEmpilhou = true;
            if (k === '__sort') {
                fecharPop();
            }
            return;
        }
        if (i.closest('#sheetFacetBody')) {
            lerOpcoes($('sheetFacetBody'), S.rascunho);
            atualizarBotaoRascunho('facetApply');
            return;
        }
        if (i.closest('#sheetFiltrosBody')) {
            lerOpcoes($('sheetFiltrosBody'), S.rascunho);
            atualizarBotaoRascunho('allApply');
        }
    });

    document.addEventListener('input', e => {
        if (e.target.closest('#sheetBusca')) {
            atualizarBotaoRascunho('allApply');
            return;
        }
        if (!e.target.matches('[data-fsearch]')) {
            return;
        }
        const tirar = s => s.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');
        const q = tirar(e.target.value);
        const caixa = e.target.closest('.pop__body,.fgroup,#sheetFacetBody');
        $$('.opt', caixa).forEach(o => { o.hidden = q ? !tirar(o.textContent).includes(q) : o.hasAttribute('data-more'); });
        const mais = caixa.querySelector('[data-showmore]');
        if (mais) mais.hidden = !!q;
    });

    document.addEventListener('submit', e => {
        if (e.target.matches('.geo-cep')) {
            e.preventDefault();
            // A roda no botão do formulário enquanto o CEP vira o ponto (no painel de filtros a página não troca).
            const botao = e.target.querySelector('[type=submit]');
            if (!ocupado(botao)) {
                ocupar(botao);
                usarCep(e.target.querySelector('input').value).finally(() => ocupar(botao, false));
            }
        } else if (e.target.id === 'hsearch') {
            e.preventDefault();
            // No painel "Filtros", o Enter é o "Ver vagas".
            if (naGaveta()) {
                $('allApply').click();
                return;
            }
            // A roda no Buscar até a página da busca trocar.
            const botao = e.target.querySelector('[type=submit]');
            if (ocupado(botao)) {
                return;
            }
            ocupar(botao);
            buscar($('hsQ').value, $('hsL').value);
        }
    });

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && !document.querySelector('dialog[open]')) {
            if (fecharCompartilhar() || fecharPop()) {
                return;
            }
            const aberto = $$('.sheet.is-open:not(#sheetMenu)').pop();
            if (aberto) {
                fecharSheet(aberto);
                return;
            }
        }
        // Computador: setas na lista trocam a vaga do painel.
        if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && e.target.closest?.('#resList') && !ehCelular()) {
            e.preventDefault();
            const ids = idsDaLista();
            const i = ids.indexOf(vagaSelecionada());
            const j = e.key === 'ArrowDown' ? Math.min(ids.length - 1, i + 1) : Math.max(0, i - 1);
            if (ids[j]) {
                selecionarNoPainel(ids[j]);
                document.querySelector(`#resList .card[data-id="${ids[j]}"] .card__t a`)?.focus();
            }
        }
    });

    // No computador, só o card em que o mouse para (120 ms): passar o mouse pela lista pedia o corpo de cada card.
    let esperaHover = 0;
    let cardHover = null;
    document.addEventListener('pointerover', e => {
        const c = e.target.closest?.('#resList > .card[data-id]') || null;
        if (ehCelular() || c === cardHover) {
            return;
        }
        cardHover = c;
        clearTimeout(esperaHover);
        // Saiu do card (para o vão ou fora da lista) antes dos 120 ms: não pede.
        if (c) {
            esperaHover = setTimeout(() => prefetch(+c.dataset.id), 120);
        }
    });

    const fi = $('fbarIn');
    if (fi) {
        fi.addEventListener('scroll', sombrasBarra, { passive: true });
        // Arrastar com o mouse, como o dedo no celular; acima de 6 px vira arrasto e o clique no chip é engolido.
        let arrasto = null;
        fi.addEventListener('pointerdown', e => {
            if (e.pointerType !== 'mouse' || e.button !== 0) return;
            arrasto = { x: e.clientX, sl: fi.scrollLeft, id: e.pointerId, moveu: false };
        });
        fi.addEventListener('pointermove', e => {
            if (!arrasto || e.pointerId !== arrasto.id) return;
            const dx = e.clientX - arrasto.x;
            if (!arrasto.moveu) {
                if (Math.abs(dx) < 6) return;
                arrasto.moveu = true;
                fi.setPointerCapture(e.pointerId);
                fi.classList.add('is-drag');
            }
            fi.scrollLeft = arrasto.sl - dx;
        });
        const fim = e => {
            if (!arrasto || e.pointerId !== arrasto.id) return;
            const moveu = arrasto.moveu;
            arrasto = null;
            fi.classList.remove('is-drag');
            if (!moveu) return;
            const engole = ev => { ev.preventDefault(); ev.stopPropagation(); };
            fi.addEventListener('click', engole, { capture: true, once: true });
            setTimeout(() => fi.removeEventListener('click', engole, { capture: true }), 0);
        };
        fi.addEventListener('pointerup', fim);
        fi.addEventListener('pointercancel', fim);
        fi.addEventListener('dragstart', e => e.preventDefault());
    }
    $$('.tela-busca .site-h, #fbar').forEach(el => el.addEventListener('wheel', repassaRoda, { passive: false }));
    window.addEventListener('resize', () => { sizeVars(); fecharPop(); sombrasBarra(); });
    window.addEventListener('offline', () => { if ($('offline')) $('offline').hidden = false; });
    window.addEventListener('online', () => { if ($('offline')) $('offline').hidden = true; });
}

// ---------- início ----------
iniciarMedicaoPagina(D ? (S.f.paravoce ? 'para_voce' : 'busca') : modoSalvas ? 'salvas' : 'vaga_removida');
// Estado com que a página abriu (o servidor já leu os parâmetros de hoje): o Voltar até a URL de chegada volta a ele.
const chaveDaUrl = qs => {
    const p = new URLSearchParams(qs);
    ['vaga', 'pagina', 'confirmar'].forEach(k => p.delete(k));
    return p.toString();
};
const _alertaNaChegada = alertaPedidoNaUrl();
const _chegada = { chave: chaveDaUrl(window.location.search), f: JSON.parse(JSON.stringify(S.f)), ordem: S.ordem };
iniciarVaga({
    textos: T,
    lista: idsDaLista,
    total: () => totalAnuncios() || idsDaLista().length,
    temMais: () => !!$('loadMore') && !$('loadMore').hidden,
    carregarMais,
    aoAbrir: id => {
        if (!D || !idsDaLista().includes(id)) {
            return;
        }
        // O vaga.js já pôs ?vaga= e a página da própria vaga na URL.
        guardarOndeParou({ q: D.query, l: D.localNome, n: posicaoDaVaga(id), url: window.location.pathname + window.location.search });
    },
    aoSalvar: (id, salvou) => {
        // Nas vagas salvas, a que sai da lista some (o painel continua até trocar de vaga).
        if (modoSalvas && !salvou) {
            document.querySelector(`#resList .card[data-id="${id}"]`)?.remove();
        }
    }
});
iniciarBuscaTelaCheia({
    valores: () => ({ q: D?.query || '', l: _textoDoLocalAtual() }),
    aoBuscar: buscar,
    aoUsarLocalizacao: usarLocalizacao
});
iniciarAutocomplete({
    campos: [
        { inp: $('hsQ'), tipo: 'q', ctx: 'd' },
        { inp: $('hsL'), tipo: 'l', ctx: 'd' },
        { inp: $('sovQ'), tipo: 'q', ctx: 'm' },
        { inp: $('sovL'), tipo: 'l', ctx: 'm' }
    ],
    textos: textosBusca,
    obterLocal: ({ soConexao = false } = {}) => (soConexao ? localDaConexao() : (D?.localNome ? { tipo: 'cidade', nome: D.localNome, slug: D.localSlug } : null)),
    localDoTexto,
    // No painel "Filtros" a sugestão de cargo ou de local só preenche: a busca sai pelo "Ver vagas", com os filtros.
    soPreencher: naGaveta,
    aoPreencher: () => atualizarBotaoRascunho('allApply'),
    // acPick da v36: região que já é opção desta busca vira o filtro Região; outro local leva à landing do cargo nele.
    aoEscolherLocal: local => {
        const regiao = GMAP.regiao?.ops.find(o => o[0] === local.slug && o[0] !== 'brasilia-sem-regiao');
        if (regiao && !S.ponto) {
            S.f.regiao = [regiao[0]];
            if (history.state?.v2Sov) {
                _depoisDoVoltar = () => aplicar({ filtro: 'regiao', medir: true });
                fecharSov();
            } else {
                fecharSov();
                aplicar({ filtro: 'regiao', medir: true });
            }
            return;
        }
        const cargo = (ehCelular() ? $('sovQ') : $('hsQ'))?.value || D?.query || '';
        guardarBuscaRecente(cargo, local.nome);
        irPara(urlBusca(cargo, local));
    },
    aoUsarLocalizacao: usarLocalizacao
});
iniciarEventos();
iniciarLogado();
if (D) {
    if (S.ponto) {
        mostrarOrigemDoPonto();
    }
    if ($('hsQ')) {
        _buscaDaPagina = { q: $('hsQ').value, l: $('hsL').value };
    }
    desenharBarra();
    depoisDaLista();
    if (document.querySelector('.split.is-empty')) {
        medirSemResultado();
    }
    sizeVars();
    iniciarBuscaRecolhida();
    iniciarChipDaBuscaNoCelular();
    const naLista = !!D.vaga && idsDaLista().includes(D.vaga);
    // Vaga do link fora desta página da lista: o servidor mandou o endereço dela e ela abre do mesmo jeito.
    const doLink = !naLista && D.vaga && D.vagaUrl ? { id: D.vaga, titulo: '', empresa: '', logo: '', href: D.vagaUrl, pills: '' } : null;
    // Deep link (?vaga=): a lista já abre rolada até o card. No celular isso vem antes do sheet porque o pushState
    // guarda a rolagem de agora, e é para ela que o navegador volta quando o sheet fecha.
    if (naLista) {
        document.querySelector(`#resList > .card[data-id="${D.vaga}"]`)?.scrollIntoView({ block: 'center' });
    }
    if (!ehCelular() && idsDaLista().length) {
        // A vaga do link conta visualização (a pessoa escolheu abri-la); a 1ª da lista, aberta sozinha, não.
        selecionarNoPainel(naLista || doLink ? D.vaga : idsDaLista()[0], { doUsuario: false, visualizar: naLista || !!doLink, info: doLink });
    } else if (ehCelular() && (naLista || doLink)) {
        // Deep link no celular (?vaga=): abre o sheet por cima da lista.
        history.replaceState(history.state, '', (() => { const u = new URL(window.location.href); u.searchParams.delete('vaga'); return u.pathname + u.search; })());
        abrirNoSheet(D.vaga, { info: doLink });
    }
} else if (modoSalvas) {
    iniciarSalvas();
    // A lista da conta chega depois: se mudou, a página refaz; se não, só o texto passa a ser o da conta.
    document.addEventListener('v2:salvas', e => {
        if (e.detail?.mudou) {
            iniciarSalvas();
        } else {
            _contagemSalvas();
        }
    });
}
